// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => {
  const GRADIENT_PRIMARY = theme.colors.blue[7];
  const GRADIENT_SECONDARY = theme.colors.pink[7];

  return {
    container: {
      position: 'relative',
      maxWidth: 325,
      height: '100%',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.other.spacing._12,
      userSelect: 'none',

      // Ladi's CSS hack for ticket cutouts, compounded gradients and shadow
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: theme.radius.lg,
        background: `
          linear-gradient(180deg, rgba(255,255,255, 0.8) 0%, transparent 50%),
          radial-gradient(white 0%, #F1F3F5 100%)
        `,
        mask: `
          radial-gradient(circle 6px at left center, transparent 100%, black 100%),
          radial-gradient(circle 6px at right center, transparent 100%, black 100%)
        `,
        maskComposite: 'intersect',
        zIndex: 2,
      },

      '&:after': {
        content: '""',
        position: 'absolute',
        top: 6,
        left: 6,
        right: 6,
        bottom: 6,
        borderRadius: theme.radius.lg,
        boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
        zIndex: 1,
      },
    },

    contentCard: {
      border: `1.5px dashed ${theme.colors.gray2[1]}`,
      borderRadius: theme.other.spacing._8,
      padding: theme.other.spacing._16,
      paddingBottom: theme.other.spacing._24,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.other.spacing._4,
      zIndex: 2,
      width: '100%',
      height: '100%',
    },

    bonusAmountRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.other.spacing._12,
      width: '100%',
    },

    bonusAmount: {
      fontFamily: theme.other.fontFamily.hubotSans,
      fontSize: 56,
      lineHeight: '64px',
      fontWeight: 900,
      fontStretch: '75%', // Condensed variant
      textTransform: 'uppercase',
      color: 'transparent',
      background: `linear-gradient(90deg, ${GRADIENT_PRIMARY} 0%, ${GRADIENT_SECONDARY} 202.25%)`,
      backgroundClip: 'text',
      // Using SVG filter for the inset text shadow
      filter: 'url(#titleShadow)',
    },

    bonusLabel: {
      display: 'flex',
      flexDirection: 'column',
    },

    bonusLabelText: {
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.4px', // Design-specific adjustment from Figma
      background: `linear-gradient(90deg, ${GRADIENT_PRIMARY} -139.19%, ${GRADIENT_SECONDARY} 100%)`,
      backgroundClip: 'text',
      color: 'transparent',
      filter: 'url(#titleShadow)',
    },

    description: {
      color: theme.colors.gray2[3],
      textAlign: 'center',
    },

    associatedUser: {
      marginTop: theme.other.spacing._4,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.other.spacing._4,
    },
  };
});
